import { useMemo } from "react";
import "../../../shared/context/constructor.js";
import { useThisContext, useLoadingContext } from "../../../shared/context/this.js";
import "@perxis-auto/shared/lib";
import { useMergedConstructorItemProps } from "../../../shared/lib/constructor/hooks/useMergedConstructorItemProps.js";
import "../../../shared/lib/constructor/mergeConstructor.js";
import "@perxis-auto/shared";
import "react/jsx-runtime";
import "@perxis-auto/ui-kit";
import "../../../shared/config/env.js";
import "../../../shared/config/events.js";
import { formatVehicleTags } from "../../../shared/lib/format/vehicle/formatVehicleTags.js";
import "../../../shared/lib/logger/index.js";
import "react-router";
import "@perxis-auto/shared/lib/lib/is/isObject";
import "../../../shared/lib/store/createAppApi.js";
import "../../../shared/lib/store/createAppAsyncThunk.js";
import "../../../shared/lib/store/createAppSelector.js";
import "../../../shared/lib/store/createAppSlice.js";
import "redux";
import "../../../shared/lib/store/hooks/useAppDispatch.js";
import { useAppSelector } from "../../../shared/lib/store/hooks/useAppSelector.js";
import "../../../shared/lib/store/hooks/useAppStore.js";
import "../../../shared/store/config/middleware/index.js";
import { selectBenefits } from "../../../shared/store/config/model/selectors/selectBenefits.js";
import "../../../shared/store/config/model/selectors/selectBooking.js";
import "../../../shared/store/config/model/selectors/selectCredit.js";
import "../../../shared/store/config/model/selectors/selectFilterGrid.js";
import "../../../shared/store/config/model/selectors/selectFilterGridItems.js";
import "../../../shared/store/config/model/selectors/selectFilters.js";
import "../../../shared/store/config/model/selectors/selectGeo.js";
import "../../../shared/store/config/model/selectors/selectGeolocator.js";
import "../../../shared/store/config/model/selectors/selectLocationCollectionIds.js";
import "../../../shared/store/config/model/selectors/selectMaps.js";
import "../../../shared/store/config/model/selectors/selectModels.js";
import "../../../shared/store/config/model/selectors/selectSort.js";
import { selectTags } from "../../../shared/store/config/model/selectors/selectTags.js";
import "../../../shared/store/config/model/selectors/selectTradeIn.js";
import "../../../shared/store/config/model/slice.js";
import { GET_DEFAULT_CONTAINER_PROPS } from "../config/props.js";
const useContainer = (item) => {
  const props = useMergedConstructorItemProps(item, GET_DEFAULT_CONTAINER_PROPS);
  const vehicleItem = useThisContext();
  const isLoading = useLoadingContext();
  const { markersTooltipTitle } = useAppSelector(selectBenefits);
  const { enable: isTagsEnable } = useAppSelector(selectTags);
  const items = useMemo(() => {
    if (!isTagsEnable) {
      return [];
    }
    const tags = (vehicleItem == null ? void 0 : vehicleItem.data.tags) || [];
    return formatVehicleTags(tags);
  }, [isTagsEnable, vehicleItem == null ? void 0 : vehicleItem.data.tags]);
  return {
    ...props,
    items,
    tooltipTitle: markersTooltipTitle,
    isLoading
  };
};
export {
  useContainer
};
